import React from 'react';
import styles from './HeroVideoModal.scss';
import classNames from 'classnames/bind';
import {Modal} from 'reactstrap';
import {VideoCloseBtn} from '../../molecules';

const cx = classNames.bind(styles);

const HeroVideoModal = ({
  shouldPlayVideo,
  youtube,
  onStopVideo
}) => {
  return (
    <Modal
      isOpen={shouldPlayVideo}
      fade={false}
      className={cx('hero-video-modal')}
    >
      <div className={cx('hero-video-modal__dimmer', (shouldPlayVideo && 'show'))}>
        <div className={cx('embed-responsive', 'embed-responsive-16by9')}>
          {youtube}
          <VideoCloseBtn
            onStopVideo={onStopVideo}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HeroVideoModal;


// WEBPACK FOOTER //
// ./src/app/components/organisms/HeroVideoModal/HeroVideoModal.js